// extracted by mini-css-extract-plugin
export default {"Stage":"ManageVariables_Stage__oO+Ky"};